import { createContext } from 'react';

export interface PortalContextProps {
  getElement: <T extends HTMLElement = HTMLElement>(portalId: string, createTopLevelPortal: boolean) => T;
  setElement: <T extends HTMLElement = HTMLElement>(portalId: string, node: T | null) => void;
}
export const PortalContext = createContext<PortalContextProps | null>(null);
PortalContext.displayName = 'PortalContext';

/** A unique identifier of our top-level portals */
export const PORTAL_PARENT_CLASS = '__portal-parent__';
